<script setup lang="ts">
import { useGlobals } from '@/helpers/globals'
import { ShWappenSvg } from '@/helpers/images'

withDefaults(
    defineProps<{
        app: boolean
        small?: boolean
    }>(),
    {
        app: false,
        small: false,
    },
)

const env = useGlobals().config?.env
</script>

<template>
    <v-app-bar :app="app" class="kp-header" :class="env ? env : ''">
        <img :src="ShWappenSvg" height="45" alt="Schaffhausen Wappen" class="mr-3" />
        <div>
            <h1 class="title">
                {{ $t('g_efp') }}
            </h1>
            <div class="subtitle">
                {{ $t('k_tg_sh') }}
            </div>
        </div>
    </v-app-bar>
</template>
